import { NgForOf, NgIf } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { AccountService } from '@core/auth/account.service';
import { PersonService } from '@core/user/person.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateDirective } from '@language/translate.directive';
import { IPersonYoung } from '@model/client/person-young.model';
import { IPersonToInstitutionEntityFunctionClient } from '@model/client/person-to-institution-entity-function-client.model';
import { ISectorIdentificationClient } from '@model/client/sector-identification-client.model';
import { IPortugueseAddressClient } from '@model/client/portuguese-address-client.model';
import { IForeignAddressClient } from '@model/client/foreign-address-client.model';
import { IPersonRelationshipClient } from '@model/client/person-relationship-client.model';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavLink, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'jhi-profile',
  templateUrl: './profile.component.html',
  imports: [
    NgbNav,
    NgbNavItem,
    FontAwesomeModule,
    TooltipModule,
    TranslateModule,
    NgbNavOutlet,
    NgbNavLink,
    NgbNavContent,
    TranslateDirective,
    NgForOf,
    NgIf,
  ],
  standalone: true,
})
export class ProfileComponent implements AfterViewInit {
  record?: IPersonYoung;

  constructor(private accountService: AccountService, protected personService: PersonService) {}

  trackId(index: number, item: any): void {
    return item.id;
  }

  getInstitutions(): IPersonToInstitutionEntityFunctionClient[] {
    return this.record?.institutions || [];
  }

  getSectorIdentifications(): ISectorIdentificationClient[] {
    return this.record?.sectorIdentifications || [];
  }

  getPortugueseAddress(): IPortugueseAddressClient[] {
    return this.record?.portugueseAddress || [];
  }

  getForeignAddress(): IForeignAddressClient[] {
    return this.record?.foreignAddress || [];
  }

  getPersonRelationships(): IPersonRelationshipClient[] {
    return this.record?.personActiveRelationships || [];
  }

  ngAfterViewInit(): void {
    this.record = this.accountService.getPerson();
  }

  previousState(): void {
    window.history.back();
  }
}
